import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { C } from "./ipd-billing/constants";
import SvgIcon from "./ipd-billing/SvgIcon";
import PackageAdminList from "./ipd-billing/components/PackageAdminList";
import PackageAdminEditor from "./ipd-billing/components/PackageAdminEditor";

// ─────────────────────────────────────────────────────────────────────────────
// IPD Package Billing admin (manager landing tile → /package-billing)
//
// Stage A only (see readmd/ipd-package-billing-flow 1.md): tenant-wide package
// setup — create package, tariffs, components, publish.
//
// Two internal views:
//   list   — packages (create / edit / copy / deactivate)
//   editor — one package: header + versions + tariffs + components + publish
// Rendered inside IPDBillingAppShell (app navbar + background), no sidebar —
// same pattern as CorporateRateCard.js.
// ─────────────────────────────────────────────────────────────────────────────
export default function PackageBilling() {
  const history = useHistory();
  // view = { name: "list" } | { name: "editor", packageId }
  const [view, setView] = useState({ name: "list" });

  const openEditor = (packageId = null) => setView({ name: "editor", packageId });
  const backToList = () => setView({ name: "list" });

  return (
    <div style={{ minHeight: "calc(100vh - 140px)", background: C.bg }}>
      <style>{`
        @keyframes ipdFadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
        @keyframes ipdShimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        .pkg-btn { transition: background 0.12s, box-shadow 0.12s; }
      `}</style>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 32px",
          background: C.card,
          borderBottom: `1px solid ${C.border}`,
        }}
      >
        <button
          onClick={() => (view.name === "editor" ? backToList() : history.push("/main-landing"))}
          className="pkg-btn"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "7px 12px",
            background: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: "8px",
            color: C.text,
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <SvgIcon name="back" size={16} color={C.text} />
          {view.name === "editor" ? "Packages" : "Home"}
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "9px",
              background: C.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SvgIcon name="package" size={18} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: "17px", fontWeight: 800, color: C.text }}>
              Package Billing
            </div>
            <div style={{ fontSize: "11px", color: C.textSub, fontWeight: 600 }}>
              Fixed-price package setup · tenant-wide
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "24px 32px" }}>
        {view.name === "list" ? (
          <PackageAdminList onOpenEditor={openEditor} />
        ) : (
          <PackageAdminEditor
            packageId={view.packageId}
            onBack={backToList}
            onSaved={openEditor}
          />
        )}
      </div>
    </div>
  );
}
